import useIntersectionObserver from './useIntersectionObserver';
import ScrambleText from './ScrambleText';
import MagneticWrapper from './MagneticWrapper';

const Resume = () => {
  const [ref, isInView] = useIntersectionObserver();

  return (
    <div ref={ref} className={`section-wrap ${isInView ? 'show' : 'hidden'}`} id="resume">
      <div className="section-head">
        <div className="section-eye">My credentials</div>
        <ScrambleText text="Resume" className="section-title" />
        <div className="section-rule" />
      </div>

      <div className="resume-card">
        <div className="resume-card-left">
          <div className="resume-icon">📄</div>
          <div>
            <div className="resume-filename">JM_Balatico_Resume.pdf</div>
            <div className="resume-meta">Updated 2026 · Software Engineer</div>
          </div>
        </div>
        <div className="resume-card-actions">
          <MagneticWrapper>
            <a className="btn-ghost" href="/JM_Balatico_Resume.pdf" target="_blank" rel="noreferrer">
              View PDF ↗
            </a>
          </MagneticWrapper>
          <MagneticWrapper>
            <a className="btn-primary" href="/JM_Balatico_Resume.pdf" download="JM_Balatico_Resume.pdf">
              Download →
            </a>
          </MagneticWrapper>
        </div>
      </div>
    </div>
  );
};

export default Resume;
